<form [formGroup]="mainForm">
    <h1 mat-dialog-title>{{ 'KPI_TYPE_ADD_DIALOG.TITLE' | translate }}</h1>
    <div mat-dialog-content>

      <div class="flex-v">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'KPI_TYPE_ADD_DIALOG.NAME_LABEL' | translate }}</mat-label>
          <input matInput formControlName="name" cdkFocusInitial>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>{{ 'KPI_TYPE_ADD_DIALOG.UNIT_LABEL' | translate }}</mat-label>
          <input matInput formControlName="unit">
        </mat-form-field>
      </div>

    </div>
    <div mat-dialog-actions class="flex-h flex-end">
      <button mat-flat-button color="primary" (click)="ok()" type="submit">{{ 'GENERAL.OK' | translate }}</button>
      <button mat-flat-button color="accent" [mat-dialog-close]>{{ 'GENERAL.CANCEL' | translate }}</button>
    </div>
  </form>
